import Chaplin from 'chaplin';
import ModulesCollection from 'ef/collections/modules_collection';
import _ from 'lodash';

// # EF.Models.Group
//
// Group is the level model above modules with modules inside them.  This model
// provides an interface for retrieving data about a group and its modules.
const Group = Chaplin.Model.extend({
  initialize: function (attrs) {
    this.currentModule = null;

    _.bindAll(this, 'attachCompletionEvents');

    this.initModules(attrs.modules || []);
  },

  defaults: {
    completed: false,
    status: 'incomplete',
  },

  initModules: function (modules, options) {
    this.set('modules', new ModulesCollection(modules, options));
    this.modules = this.get('modules');
  },

  attachCompletionEvents: function () {
    const self = this;

    this.set('completed', this.isComplete());
    const completionHandler = () => {
      if (!self.get('completed')) {
        return;
      }
      self.set('status', 'complete');
    };

    this.on('change:completed', completionHandler);
  },

  getStartingModule: function () {
    const firstNotComplete = this.modules.find(function (module) {
      return !module.isComplete();
    });

    if (firstNotComplete) {
      this.currentModule = firstNotComplete;
      return firstNotComplete;
    } else {
      this.currentModule = null;
      return false;
    }
  },

  isComplete: function () {
    return this.modules.every(function (module) {
      return module.isComplete();
    });
  },
});

export default Group;
